export default __webpack_public_path__ + "static/media/analytics.000b0b67.svg";